export function setNumberArrayConfig(fieldname: string) {
  return {
    columns: [
      {
        typeAndFormat: {
          type: 'number'
        },
        fieldName: fieldname
      }
    ]
  };
}
